import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-panel__row assessment-level" }
const _hoisted_2 = { class: "profile-headline" }
const _hoisted_3 = { class: "profile-headline__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxButton = _resolveComponent("PxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("profile.assessment.levelPanel.title")), 1),
      (_ctx.allowLevelUpdate)
        ? (_openBlock(), _createBlock(_component_PxButton, {
            key: 0,
            disabled: !_ctx.$features.isEnabled('updateLevel'),
            class: "profile-headline__updateBtn",
            size: "small",
            onClick: _ctx.onClickUpdateLevelBtn
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("profile.assessment.update")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      class: "assessment-level__indicator assessment-level__indicator--disabled",
      src: "/img/placeholders/level.svg"
    }, null, -1))
  ]))
}